import React from 'react';
import EnhancedTableBase from '../../../components/common/EnhancedTable/EnhancedTableBase';
import { EnhancedTableProps } from '../../../components/common/EnhancedTable/types';
import './EnhancedApplicants.css';

/**
 * EnhancedApplicantsTable component
 * 
 * This component extends the EnhancedTableBase component with specific styling and behavior
 * for the Applicants page.
 */
function EnhancedApplicantsTable<T extends Record<string, any>>(props: EnhancedTableProps<T>) {
  return (
    <EnhancedTableBase
      {...props}
      className={`${props.className || ''}`}
      defaultSort={props.defaultSort}
      onSort={props.onSort}
    />
  );
}

export default EnhancedApplicantsTable;
